const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  paperAnchorLeft: {
    width: 300,
    overflowX: 'hidden',
  },
});

export default styles;
